export const fetchAccountBalance = () => {
  return (dispatch, getState) => {
    const state = getState()
    const { organization, resident } = state

    dispatch({type: 'BEGIN_FETCH_ACCOUNT_BALANCE'})
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/account_balance.json`,
      success: (response) => {
        dispatch({type: 'SUCCESS_FETCH_ACCOUNT_BALANCE', payload: response })

      },
      errors: () => {
        dispatch({type: 'FAILED_FETCH_ACCOUNT_BALANCE'})

      }
    })
  }
}